export default __webpack_public_path__ + "static/media/emissary.f3a358f3.png";